import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestUpdateAnnouncement } from "./updateAnnouncement.request";

const useUpdateAnnouncement = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateAnnouncement,
    ...options
  });
};

export default useUpdateAnnouncement;
